import styled, { css } from 'styled-components';
import { Table, FovButton } from 'components/generic';
import { getColor } from 'utils';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const DashboardContainer = styled('div')`
    ${props => props.$onArchVisionAdmin && css`
        display: grid;
        grid-template-columns: ${props.$navCollapsed ? '4rem' : '18rem'} 1fr;
        transition: grid-template-columns 0.2s ease;
    `}

    width: 100%;
    height: 100%;
    color: ${props => getColor(props, 'onPrimary')};
    overflow-y: auto;
`;

export const ArchVisionAdminNavPanel = styled('div')`
    width: 100%;
    height: 100%;
    padding: 3.25rem 0 1rem 0;
    border-right: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
    overflow-y: auto;
`;

export const NavCollapseToggle = styled('div')`
    display: flex;
    align-items: center;
    justify-content: ${props => props.$collapsed ? 'center' : 'flex-end'};
    padding: 0 1rem 1rem 1rem;
    transition: justify-content 0.2s ease;
    cursor: pointer;
`;

export const NavContent = styled('div')`
    display: ${props => props.$collapsed ? 'none' : 'block'};
    padding: 0 2rem;
`;

export const MainContent = styled('div')`
  overflow-y: auto;
`;

export const PanelTitle = styled('div')`
    display: inline-flex;
`;

export const CategoryName = styled('div')`
    color: ${props => props.$selected && getColor(props, 'accent')};
    font-family: ${props => props.theme.typography.primary.regular};
    display: grid;
    grid-template-columns: repeat(2, auto) 1fr;
    gap: 0.5rem;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-style: normal;
    font-size: 1.05rem;
    font-weight: 600;
    letter-spacing: 0.05rem;
    margin: 0;

    &:hover {
        color: ${props => getColor(props, 'accentHover')};
    }
`;

export const CardsContainer = styled('div')`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  padding: ${props => props.$onArchVisionAdmin ? '0 2rem 1rem 2rem' : '1rem'};
`;

export const PageContent = styled('div')`
    width: 100%;
`;

export const TabContainer = styled('div')`
    position: relative;
    display: inline-flex;
    padding: 1rem 0;
    width: 100%;
`;

export const Tab = styled(FovButton)`
    position: relative;
    width: fit-content;
    margin: 0 0.5rem;
    background-color: ${props => {
        return getColor(props, props.selected ? 'accent' : 'onPrimary');
    }};
    &:hover {
        background-color: ${props => getColor(props, 'accentHover')};
    }

`;

export const IconButton = styled(FovButton)`
    width: fit-content;
    padding: 0;
    background-color: ${props => getColor(props, props?.backgroundColor || 'primary')};

    &:hover {
       background-color: ${props => {
        const lightTheme = props.$selectedTheme === light;
        return props?.hoverColor || getColor(props, lightTheme ? 'mediumGrey' : 'accent');
       }};
    }
`;

export const NameContainer = styled('div')`
    padding-right: 0.5rem;
    width: 18rem;
`;

export const HeaderContainer = styled('div')`
    width: 100%;
    display: inline-flex;
`;

export const SortContainer = styled('div')`
    width: fit-content;
    margin-right: 0;
    margin-left: auto;
    min-width: 15rem;
`;

export const MemberContainer = styled(Table)`
    border: 0.0625rem solid #ccc;
    border-radius: 0.25rem;
    border-color: ${props => getColor(props, 'mediumGrey')};
`;
export const TableThumbnail = styled.img`
  width: auto;
  height: 5.25rem;
  max-width: 6.25rem;
  max-height: 6.25rem;
  border-radius: 0.35rem;
`;